import { sortBy } from 'lodash';

export const sortDepartmentsByName = <T extends { displayName: string }>(
	departments: T[],
): T[] => {
	return sortBy(departments, (department) =>
		department.displayName.replace(/^the\s+/i, ''),
	);
};
